// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Constants
import { DOWNLOAD_LINK_PROPS, PDF_VIEWER_PROPS } from '../../constants/contract.constants';
import { FINANCIAL_DATA_PROPS, SIGNING_TITLE_PROPS } from './constants/contract.view.constants';
// Components
import {
  ButtonComponent,
  ParagraphComponent,
  PDFViewerComponent,
  SelectorRowComponent,
} from '@openbank/ziniaweb-ui-components';
import { FinancialDataComponent } from '../../components/financial-data/financial-data.component';
// Hooks
import { useContractHook } from './hooks/contract.view.hook';
import { useContractContainerHook } from '../../hooks/contract.hook';
// Styles
import {
  ContractComponentStyled,
  ContractPDFAndConsentsAreaStyled,
  ContractPDFViewerAreaStyled,
  ConsentsContainerStyled,
  SignatureDateStyled,
} from './contract.view.styled';
// Translations
import {
  CONSENT,
  CONSENTS_TITLE,
  DOWNLOAD_CONTRACT_INFORMATION,
  DOWNLOAD_LINK_CONTRACT,
  INFORMATION_TITLE,
  LEGAL_CONSENTS_TEXT,
  SIGNATURE_DATE,
} from './translations/contract.view.translations';
// Utils
import { getFormattedDate } from './utils/contract.view.utils';
import { getConsentProps } from '../../utils/contract.utils';
import { createObjectUrlFromBlob } from '@openbank/cf-ui-framework';

const ContractView = (): React.JSX.Element => {
  const { screenDetails, consents, handleCheckConsent, handleDownloadPdfButtonClickTracking } =
    useContractHook();

  const { financialData, formatMessage, handleDownloadDocument } = useContractContainerHook();

  return (
    <ContractComponentStyled>
      {screenDetails?.document && (
        <ContractPDFAndConsentsAreaStyled>
          <ContractPDFViewerAreaStyled>
            <PDFViewerComponent
              {...PDF_VIEWER_PROPS}
              pdfUrl={createObjectUrlFromBlob(screenDetails?.document?.byteCode as Blob)}
            />
          </ContractPDFViewerAreaStyled>
          <ConsentsContainerStyled>
            <ButtonComponent
              {...DOWNLOAD_LINK_PROPS}
              onClick={evt => {
                evt.preventDefault();
                handleDownloadPdfButtonClickTracking();
                handleDownloadDocument(
                  DOWNLOAD_LINK_CONTRACT,
                  screenDetails?.document?.byteCode as Blob
                );
              }}
            >
              <FormattedMessage id={DOWNLOAD_CONTRACT_INFORMATION} />
            </ButtonComponent>
            <ParagraphComponent>
              <FormattedMessage id={LEGAL_CONSENTS_TEXT} />
            </ParagraphComponent>
            <ParagraphComponent {...SIGNING_TITLE_PROPS}>
              <FormattedMessage id={CONSENTS_TITLE} />
            </ParagraphComponent>
            <SignatureDateStyled>
              <FormattedMessage id={SIGNATURE_DATE} /> {getFormattedDate()}
            </SignatureDateStyled>
            {consents &&
              consents.map((consent, index) => (
                <SelectorRowComponent
                  key={index}
                  {...getConsentProps({
                    CONSENT,
                    formatMessage,
                    type: consent.type,
                  })}
                  onToggleChange={() => handleCheckConsent(consent.type)}
                  onCheckboxChange={() => handleCheckConsent(consent.type)}
                  selected={consent.checked}
                />
              ))}
          </ConsentsContainerStyled>
        </ContractPDFAndConsentsAreaStyled>
      )}
      <FinancialDataComponent
        data={financialData}
        title={INFORMATION_TITLE}
        {...FINANCIAL_DATA_PROPS}
      />
    </ContractComponentStyled>
  );
};

export { ContractView };
